<template>
  <el-dialog
    title="编辑链接"
    :visible.sync="isVisitle"
    width="30%"
  >
    <el-form label-width="100px" :form="value" :model="value" :rules="rules">
      <el-form-item label="渠道名称：">
        <el-input :disabled="true" v-model="mixedData.ch_path" class="jm-input280"></el-input>
      </el-form-item>
      <el-form-item label="url：" prop="url">
        <el-input v-model="value.url" class="jm-input280"></el-input>
      </el-form-item>
      <el-form-item label="推广备注：">
        <el-input v-model="value.comment" class="jm-input280"></el-input>
      </el-form-item>
      <el-form-item label="宽度：">
        <el-input v-model="value.qr_size" type="number" class="jm-input280"></el-input>
      </el-form-item>
      <el-form-item label="二维码类别：">
        <el-select
          v-model="value.qr_type"
          class="jm-input280"
          placeholder="请选择">
          <el-option
            v-for="{ value, label } in qrTypes"
            :key="value"
            :label="label"
            :value="value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="类型：" v-if="value.qr_type > 0">
        <el-switch
          v-model="value.qr_shape"
          active-color="#13ce66"
          inactive-color="#409EFF"
          :active-value="2"
          :inactive-value="1"
          inactive-text="二维码（方）"
          active-text="小程序码（圆）">
        </el-switch>
      </el-form-item>
      <el-form-item label="活动筛选：">
        <el-select
          v-model="value.ac_id"
          filterable
          class="jm-input280"
          clearable
          placeholder="请选择">
          <el-option
            v-for="action in actions.filter(a => 1 == a.act_status)"
            :key="action.id"
            :label="getActionLabel(action)"
            :value="action.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="二维码：">
        <img class="qrcode" :src="qrcodeUrl" />
      </el-form-item>
      <el-form-item v-if="qrcodeUrl">
        <el-button size="mini" type="primary" @click="downloadQrcode">下载</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-if="url" type="primary" @click="copyUrl">复制URL</el-button>
      <el-button type="primary" :disabled="isSubmiting" @click="handleGetQrcode">生成二维码</el-button>
      <el-button type="primary" :disabled="isSubmiting" @click="hanleSubmit(false)">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditDialog',
  props: {
    visible: {
      type: [Boolean],
      default: false
    },
    onCancle: {
      type: [Function, null],
      default: null
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    onSubmited: {
      type: [Function, null],
      default: null
    },
    qrTypes: {
      type: Object,
      default() {
        return [];
      }
    },
    actions: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data () {
    return {
      qrcodeUrl: null,
      mixedData: this.initialValue,
      url: null,
      isSubmiting: false,
      value: {
        ch_id: this.initialValue.ch_id,
        qr_type: 0,
        qr_size: 200
      },
      rules: {
        url: [
          { required: true, message: 'URL 不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    checkValue() {
      if (!this.value.url) {
        this.$message.error('URL 不能为空');
        return false;
      }
      if (!parseInt(this.value.qr_size, 10) || parseInt(this.value.qr_size, 10) < 0) {
        this.$message.error('二维码宽度必须为大于 0 的整数');
        return false;
      }
      if (this.value.qr_type === undefined) {
        this.$message.error('二维码类别不能为空');
        return false;
      }
      return true;
    },
    handleCancel () {
      this.onCancle && this.onCancle();
    },
    downloadQrcode() {
      const a = document.createElement('a');
      a.download = this.mixedData.ch_path;
      a.href = this.qrcodeUrl;
      a.click();
    },
    async hanleSubmit () {
      if (this.isSubmiting) {
        return false;
      }
      if (!this.checkValue()) {
        return false;
      }
      this.isSubmiting = true;
      this.value.ch_id = this.initialValue.ch_id;
      const { data } = await this.$http._post({
        url: '/training/channel/promotionsSave',
        data: this.value
      });
      this.qrcodeUrl = data.qrUrl;
      this.onSubmited && this.onSubmited(data);
      this.isSubmiting = false;
    },
    async handleGetQrcode() {
      if (this.isSubmiting) {
        return false;
      }
      if (!this.checkValue()) {
        return false;
      }
      this.isSubmiting = true;
      this.value.ch_id = this.initialValue.ch_id;
      const { data } = await this.$http._post({
        url: '/training/channel/getPromotionQrcode',
        data: this.value
      });
      this.qrcodeUrl = data.qrcode;
      this.url = data.url;
      this.isSubmiting = false;
    },
    copyUrl() {
      const input = document.createElement('input');
      input.value = this.url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    getActionLabel (action) {
      const title = action.act_title;
      const map = {
        fib: '蓝火 - ',
        job: '求职 - ',
        training: '考培 - '
      };
      const siteName = map[action.site_name] || '';
      return `${siteName}${title}`;
    }
  },
  computed: {
    isVisitle: {
      get() {
        return this.visible;
      },
      set(value) {
        this.onCancle && this.onCancle();
        if (!value) {
          this.value = {
            qr_size: 200,
            qr_type: 0
          };
        }
      }
    }
  },
  watch: {
    initialValue: {
      handler (newValue) {
        this.mixedData = newValue;
        this.value = {
          qr_size: 200,
          qr_type: 0
        };
        if (this.visible) {
          const { ch_id: chId } = this.mixedData;
          this.value.ch_id = chId;
          this.qrcodeUrl = null;
          this.url = null;
        }
      },
      deep: true
    }
  }
};
</script>

<style>
.qrcode {
  width: 200px;
  height: 200px;
  border:1px solid #EEE;
}
</style>
